import {
  FaStar,
  FaReply,
  FaUserCircle,
  FaCalendarAlt,
  FaShoppingBag,
} from "react-icons/fa";

import "./ReviewCard.css";

function ReviewCard({ review, onReply }) {
  return (
    <div className="review-card">

      <div className="review-top">

        <div className="customer-info">

          <div className="customer-avatar">
            <FaUserCircle />
          </div>

          <div>

            <h3>{review.customerName}</h3>

            <div className="review-stars">

              {[1,2,3,4,5].map((star)=>(
                <FaStar
                  key={star}
                  className={
                    star <= review.rating
                      ? "star filled"
                      : "star"
                  }
                />
              ))}

            </div>

          </div>

        </div>

        <button
          className="reply-btn"
          onClick={() => onReply(review)}
        >
          <FaReply />
          {review.reply ? "Edit Reply" : "Reply"}
        </button>

      </div>

      <p className="review-text">
        {review.review}
      </p>

      <div className="review-meta">

        <span>
          <FaShoppingBag />
          Order #{review.orderId}
        </span>

        <span>
          <FaCalendarAlt />
          {review.date}
        </span>

      </div>

      {review.reply && (

        <div className="provider-reply">

          <h4>Provider Reply</h4>

          <p>{review.reply}</p>

        </div>

      )}

    </div>
  );
}

export default ReviewCard;